import { PolicyStateFeedback } from "../policy-state";

export function PolicyVersionIdentitySkeleton() {
  return (
    <section aria-busy="true" aria-label="Loading policy details">
      <PolicyStateFeedback
        state={{ status: "loading" }}
        subject="policy details"
      />
    </section>
  );
}
